import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', value: 'number_index', align: 'start', width: '10' },
  { text: 'Bill Number', value: 'bill_num', width: '150'},
  { text: 'Aggregator Name', value: 'aggregator_name' },
  { text: 'Merchant Name', value: 'merchant_name' },
  { text: 'Request ID', value: 'request_id' },
  { text: 'MID', value: 'mid', width: '150' },
  { text: 'Merchant PAN', value: 'mpan', width: '150' },
  { text: 'Reff ID', value: 'rrn', width: '150' },
  { text: 'QR Method', value: 'qr_method', width: '100', align: 'center', textAlign: 'text-center' },
  { text: 'QR Type', value: 'qr_type', width: '100', align: 'center', textAlign: 'text-center' },
  { text: 'Transaction Type', value: 'trx_type', align: 'center', textAlign: 'text-center' },
  { text: 'Issuer Name', value: 'issuer_name', width: '150' },
  { text: 'Customer PAN', value: 'customer_pan', width: '150' },
  { text: 'Customer Name', value: 'customer_name', width: '150' },
  { text: 'Payment Type', value: 'payment_type', width: '100', align: 'center', textAlign: 'text-center' },
  { text: 'Acquirer Name', value: 'payment_channel', width: '150'},
  { text: 'Amount', value: 'amount', width: '150', align: 'center', textAlign: 'text-right' },
  { text: 'MDR', value: 'amount_mdr', width: '150', align: 'center', textAlign: 'text-right' },
  { text: 'Net Amount', value: 'amount_net', width: '150', align: 'center', textAlign: 'text-right' },
  { text: 'Transaction Date', value: 'trx_datetime', width: '150', align: 'center' },
  { text: 'Status', value: 'status', width: '100', align: 'center', textAlign: 'text-center' },
  { text: 'Settlement Status', value: 'settlement_status', width: '100', align: 'center', textAlign: 'text-center' },
  { text: 'Source of Fund', value: 'payment_method', width: '150', align: 'center' },
  { text: 'Additional Data', value: 'additional_data', width: '180', align: 'center' },
  { text: 'Action', value: 'action',  width: '100', align: 'center' },
]);
export const search = {
  trx_datetime: [],
  ac_id: '',
  payment_type: '',
  rrn: '',
  mid: '',
  status: '',
  bill_num: '',
};

export const editedItem = {
  bill_num: '',
  merchant_name: '',
  mid: '',
  mpan: '',
  rrn: '',
  qr_method: '',
  qr_type: '',
  trx_type: '',
  customer_pan: '',
  payment_method: '',
  payment_type: '',
  payment_channel: '',
  amount: '',
  currency: '',
  amount_mdr: '',
  net_amount: '',
  trx_datetime: '',
  status: '',
  settlement_status: '',
};